import { type ObjectValuesUnionType } from '../../../../utils/typing';

export const LineUpActionTypes = Object.freeze({
  CLOSE_NOTIFICATIONS_INFOS_POP_UP: 'LINE_UP:CLOSE_NOTIFICATIONS_INFOS_POP_UP',
  PROGRESSIVELY_OPEN_VIEW: 'LINE_UP:PROGRESSIVELY_OPEN_VIEW',
});
export type LineUpActionType = ObjectValuesUnionType<typeof LineUpActionTypes>;
